"use client";

import { RouteErrorBoundary } from "@/app/_components/ui/route-error-boundary";

export default function AppGroupError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteErrorBoundary boundary="(app)" error={error} reset={reset} />;
}
